import { useIntl } from 'react-intl';
import { cx } from '@emotion/css';

import { ButtonProps } from './button.models';
import { useStyles } from './button.styles';

export const Button = ({
  children,
  to,
  style,
  rootClasses,
  textClasses,
  ariaLabel,
  onClick,
  hideText,
  startIcon,
  isUnderline,
  testId,
  ...rest
}: ButtonProps): JSX.Element => {
  const classes = useStyles();
  const intl = useIntl();

  return (
    <>
      {to ? (
        <a
          {...rest}
          href={to}
          className={cx(classes.root, style, rootClasses,
            { [classes.isUnderline]: isUnderline })}
          aria-label={ariaLabel && intl.formatMessage({ id: ariaLabel })}
          data-testid={testId}
        >
          {startIcon}
          {!hideText && <span className={textClasses}>{children}</span>}
        </a>
      ) : (
        <button
          {...rest}
          aria-label={ariaLabel && intl.formatMessage({ id: ariaLabel })}
          className={cx(classes.root, style, rootClasses,
            { [classes.isUnderline]: isUnderline })}
          onClick={onClick}
          data-testid={testId}
        >
          {startIcon}
          {!hideText && <span className={textClasses}>{children}</span>}
        </button>
      )}
    </>
  );
};
